import { LIST_ITEM_LOCAL_KEY } from '../constants';

const setItemListId = (listName, id) => {
  const localListName = `${LIST_ITEM_LOCAL_KEY}${listName}`;
  localStorage.setItem(localListName, id);
  window.dispatchEvent(new Event('storage'));
};

export default setItemListId;
